import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { TextRenderer } from "@/react/components/shared/BuilderUI/DefaultBlocks/Content/RichText/TextRenderer";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { defaultStyles } from "./defaultStyles";

interface BadgeProps extends ComponentPropsWithRef<"span"> {
  blockPath: string;
  styles?: Record<string, StyleValue>;
  text: string;
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ text, blockPath, styles = {}, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles, defaultStyles });

    return (
      <span
        ref={ref}
        className={classNames(
          "wb-border-button-secondary wb-bg-secondary wb-text-primary wb-w-fit wb-rounded-2xl wb-border wb-px-4 wb-py-1.5 wb-text-sm",
          className,
        )}
        style={inlineStyles}
        {...rest}
      >
        <TextRenderer blockPath={blockPath} text={text} />
      </span>
    );
  },
);
Badge.displayName = "Badge";
